export default __webpack_public_path__ + "static/media/SupplierNetwork.ed19a849.svg";